import React from 'react';
import styled from 'styled-components';

import { ContentWrapper } from '../../styles';
import ErrorIconRenderer from './ErrorIconRenderer';
import ErrorText from './ErrorText'; 
import { ErrorProps } from './types';

const Error = ({ tenant, error, isExpired = false }: ErrorProps) => {
    return (
        <StyledWrapper>
            <ErrorIconRenderer error={ error }
                isExpired={ isExpired }/>
            <ErrorText tenant={ tenant }
                error={ error }
                isExpired={ isExpired }/>
        </StyledWrapper>
    );
};

export default Error;

const StyledWrapper = styled(ContentWrapper)`
    padding-left: ${ ({ theme }) => theme.size.size_20 };
    padding-right: ${ ({ theme }) => theme.size.size_20 };
    flex: 1;
`;
